import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export interface Testimonial {
  quote: string;
  name: string;
  photo: string;
}
interface TestimonialsCarouselProps {
  testimonials: Testimonial[];
  interval?: number;
}
export function TestimonialsCarousel({
  testimonials,
  interval = 5000
}: TestimonialsCarouselProps) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused || testimonials.length <= 1) return;
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % testimonials.length);
    }, interval);
    return () => clearInterval(id);
  }, [paused, testimonials.length, interval]);
  const current = testimonials[index];
  return <div className="w-full max-w-2xl mx-auto" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} aria-roledescription="carousel" aria-label="Testimonionan" data-id="element-75" data-mp="15ntr3nkgm0zk">
      <div className="relative min-h-[300px] sm:min-h-[260px] flex items-center justify-center" data-id="element-76" data-mp="2iay5mn2r0d6j">
        <AnimatePresence mode="wait" data-id="element-77" data-mp="2na15lt3vft7n">
          <motion.figure key={index} initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -24
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="w-full flex flex-col items-center text-center bg-white/5 border border-brand-gold/20 rounded-2xl p-8 md:p-10 backdrop-blur-sm" data-id="element-78" data-mp="2nb2nohjb1fyv">
            <img src={current.photo} alt={`Foto di ${current.name}`} className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-2 border-brand-gold/60 mb-5 shadow-[0_0_25px_rgba(200,150,46,0.25)]" loading="lazy" data-id="element-79" data-mp="3f0yyax68ndt4" />
            <blockquote className="text-lg md:text-xl text-gray-100 font-light leading-relaxed italic mb-5" data-id="element-80" data-mp="1ox580rg03i9n">
              “{current.quote}”
            </blockquote>
            <figcaption className="text-sm tracking-[0.2em] text-brand-gold/90 font-medium uppercase" data-id="element-81" data-mp="1jzvhf8gvl0k8">
              {current.name}
            </figcaption>
          </motion.figure>
        </AnimatePresence>
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-3 mt-6" data-id="element-82" data-mp="27nd4wrt3xche">
        {testimonials.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Bai na testimonio ${i + 1}`} aria-current={i === index} className={`h-2.5 rounded-full transition-all duration-300 ${i === index ? 'w-7 bg-brand-gold' : 'w-2.5 bg-brand-gold/30 hover:bg-brand-gold/60'}`} data-id="element-83" data-mp="23mbduy9cg6qi" data-mpi={i} />)}
      </div>
    </div>;
}